export interface BusinessHours {
  [key: string]: {
    isOpen: boolean;
    startTime: string;
    endTime: string;
  };
}

// Backend expects this format
export interface BackendBusinessHours {
  [key: string]: {
    isOpen: boolean;
    openTime?: string;
    closeTime?: string;
  };
}

export const DEFAULT_BUSINESS_HOURS: BusinessHours = {
  monday: { isOpen: true, startTime: '9:00 AM', endTime: '5:00 PM' },
  tuesday: { isOpen: true, startTime: '9:00 AM', endTime: '5:00 PM' },
  wednesday: { isOpen: true, startTime: '9:00 AM', endTime: '5:00 PM' },
  thursday: { isOpen: true, startTime: '9:00 AM', endTime: '5:00 PM' },
  friday: { isOpen: true, startTime: '9:00 AM', endTime: '5:00 PM' },
  saturday: { isOpen: false, startTime: '9:00 AM', endTime: '5:00 PM' },
  sunday: { isOpen: false, startTime: '9:00 AM', endTime: '5:00 PM' },
};

export const DAY_LABELS: Record<string, string> = {
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
};

export const TIME_OPTIONS = [
  '12:00 AM', '12:30 AM', '1:00 AM', '1:30 AM', '2:00 AM', '2:30 AM',
  '3:00 AM', '3:30 AM', '4:00 AM', '4:30 AM', '5:00 AM', '5:30 AM',
  '6:00 AM', '6:30 AM', '7:00 AM', '7:30 AM', '8:00 AM', '8:30 AM',
  '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM',
  '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM',
  '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM',
  '6:00 PM', '6:30 PM', '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM',
  '9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM'
];

const convertTo24Hour = (time12h: string): string => {
  const [time, modifier] = time12h.split(' ');
  const [hoursStr, minutes] = time.split(':');
  let hours = hoursStr;

  if (hours === '12') {
    hours = modifier === 'AM' ? '00' : '12';
  } else if (modifier === 'PM') {
    hours = String(parseInt(hours, 10) + 12);
  }

  return `${hours.padStart(2, '0')}:${minutes}`;
};

const convertTo12Hour = (time24h: string): string => {
  const [hours, minutes] = time24h.split(':');
  const hour24 = parseInt(hours, 10);

  if (hour24 === 0) return `12:${minutes} AM`;
  if (hour24 < 12) return `${hour24}:${minutes} AM`;
  if (hour24 === 12) return `12:${minutes} PM`;
  return `${hour24 - 12}:${minutes} PM`;
};

export const convertToBackendFormat = (frontendHours: BusinessHours): BackendBusinessHours => {
  const backendHours: BackendBusinessHours = {};
  Object.entries(frontendHours).forEach(([day, hours]) => {
    backendHours[day] = {
      isOpen: hours.isOpen,
      openTime: hours.isOpen ? convertTo24Hour(hours.startTime) : undefined,
      closeTime: hours.isOpen ? convertTo24Hour(hours.endTime) : undefined,
    };
  });
  return backendHours;
};

export const convertToFrontendFormat = (backendHours: BackendBusinessHours): BusinessHours => {
  const frontendHours: BusinessHours = {};
  Object.entries(backendHours).forEach(([day, hours]) => {
    frontendHours[day] = {
      isOpen: hours.isOpen,
      startTime: hours.openTime ? convertTo12Hour(hours.openTime) : '9:00 AM',
      endTime: hours.closeTime ? convertTo12Hour(hours.closeTime) : '5:00 PM',
    };
  });
  return frontendHours;
};
